import React, { useEffect } from 'react';

import CheckIcon from '@material-ui/icons/AssignmentTurnedIn';

import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useUpdateCapa } from '../Capa.hook';
import { Capa, BaseCapaCardProps } from '../Capa.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';

export type CapaVerificationCardProps = BaseCapaCardProps;

export const CapaVerificationCard: React.FC<CapaVerificationCardProps> = props => {
  const { capa, onChange, setErrorMessage, setSuccessMessage } = props;
  const { isFieldDisabled } = useTaskEntityFields(capa.task);
  const [{ data: updatedCapa, isLoading, error }, update] = useUpdateCapa(
    capa.id
  );

  useEffect(() => {
    if (updatedCapa?.id) setSuccessMessage('CAPA successfully updated');
  }, [setSuccessMessage, updatedCapa]);

  useEffect(() => {
    if (Boolean(error)) setErrorMessage('There was an error saving');
  }, [setErrorMessage, error]);

  if (!capa.id) return null;

  return (
    <InlineFormik
      initialValues={capa}
      isSubmitting={isLoading}
      error={error}
      onSubmit={(updatedValue: Partial<Capa>) => {
        update({
          ...updatedValue
        });
        onChange?.(updatedValue);
      }}
    >
      <Card>
        <CardTitle>
          <CheckIcon />
          Verification
        </CardTitle>
        <CardContent padding='large'>
          <InlineForm>
            <InlineTextField
              name='verification'
              label='Verification'
              disabled={isFieldDisabled('verification')}
              multiline={true}
            />
          </InlineForm>
        </CardContent>
      </Card>
    </InlineFormik>
  );
};

export default CapaVerificationCard;
